import React, { useState, useEffect } from 'react';

import { useMutation } from '@apollo/client';

import { initNethone, loadNethone } from 'nethone';
import CookiesManager from 'ggApp/utils/CookiesManager';

import { PAYMENT_SENSITIVE_FIELDS } from 'ggApp/modules/payment/constants';
import { SECRET_FIELDS } from 'ggApp/modules/auth/v3/constants/fieldIds';

import CreateCheckoutAttemptMutation from 'ggApp/modules/checkout/queries/CreateCheckoutAttemptMutation.graphql';

const withNethoneInitialization = (EnhancedComponent) => {
    const NethoneInitializer = (props) => {
        const { order, orderFetching } = props;
        const [isNethoneLoaded, setIsNethoneLoaded] = useState(false);
        const [isNethoneInitialized, setIsNethoneInitialized] = useState(false);
        const [checkoutAttemptReference, setCheckoutAttemptReference] = useState(null);

        const [getCheckoutAttempt, { data }] = useMutation(CreateCheckoutAttemptMutation);

        useEffect(() => {
            if (
                !orderFetching &&
                !isNethoneLoaded &&
                order &&
                (order.number || order.orderNumber)
            ) {
                const cookiesManager = new CookiesManager();
                const ggId = cookiesManager.get('ggId');
                const orderNumber = order.number || order.orderNumber;

                getCheckoutAttempt({
                    variables: { orderNumber, sessionId: ggId },
                });
                loadNethone()
                    .then(() => {
                        setIsNethoneLoaded(true);
                    })
                    .catch(() => {
                        console.warn('Neithone was not loaded.');
                    });
            }
        }, [orderFetching, order, isNethoneLoaded, getCheckoutAttempt]);

        useEffect(() => {
            if (data) {
                const { createCheckoutAttempt } = data;
                const { reference = null } = createCheckoutAttempt || {};

                setCheckoutAttemptReference(reference);
            }
        }, [data]);

        useEffect(() => {
            if (!isNethoneInitialized && checkoutAttemptReference) {
                initNethone({
                    attemptReference: checkoutAttemptReference,
                    sensitiveFields: PAYMENT_SENSITIVE_FIELDS,
                    secretFields: SECRET_FIELDS,
                });

                setIsNethoneInitialized(true);
            }
        }, [checkoutAttemptReference, isNethoneInitialized]);

        return <EnhancedComponent checkoutAttemptReference={checkoutAttemptReference} {...props} />;
    };

    return NethoneInitializer;
};

export default withNethoneInitialization;
